import { render, staticRenderFns } from "./ListFeedHeader.vue?vue&type=template&id=604295aa&"
import script from "./ListFeedHeader.vue?vue&type=script&lang=js&"
export * from "./ListFeedHeader.vue?vue&type=script&lang=js&"
import style0 from "./ListFeedHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports